<template>
  <div class="home">

    <br><br><br><br>

    <b-container fluid class="home-container">
      <b-row>
        <b-col lg="12" sm="12">
          <Header />
        </b-col>
      </b-row>

      <b-row class="quick-links-row">
        <b-col cols="1">
          <span id="fixedButton">
            <ul>
              <li v-for="item in menuItems" :key="item.id" class="menu-nav-item"
                :class="{ 'menu-nav-item-active': allOpenOnLoad || activeMenuItem === item.id }" tabindex="0"
                @mouseover="openNav(item.id)" @focus="openNav(item.id)">
                <b-icon :icon="item.icon" variant="light"></b-icon>
              </li>
            </ul>
          </span>

          <div v-for="item in menuItems" :key="item.id + '-panel'" :id="item.id + 'Sidenav'" class="sidenav"
            :class="{ open: allOpenOnLoad || activeMenuItem === item.id }" :style="{ top: item.top }"
            @mouseleave="closeNavAll()">
            <a :id="item.id" :target="item.target" :href="item.href" :aria-label="item.label">
              <b-icon :icon="item.icon"></b-icon>
              {{ item.label }}
            </a>
          </div>
        </b-col>

        <b-col cols="11">
          <div v-if="getMarquee && getMarquee.length" class="ticker-wrap">
            <div class="ticker-move">
              <span v-for="item in getMarquee" :key="item.title" class="ticker-item">
                <span class="m-text" v-html="item.title"></span>
                <span class="ticker-sep">|</span>
              </span>
            </div>
          </div>
        </b-col>
      </b-row>

      <b-row>
        <b-col cols="12">
          <div class="app-update-ribbon">
            <b-icon icon="info-circle-fill" class="mr-2"></b-icon>
            <span>
              Users facing issues with the <strong>Android version of the myBijulee mobile application</strong>
              are advised to update it to the <strong>latest version available on the Google Play Store</strong>.
            </span>
          </div>
        </b-col>
      </b-row>

      <b-row>
        <b-col cols="12">
          <!-- Sticker-style Customer Support Banner -->
          <router-link to="/ContactCustomerCare" custom target="_blank" class="customer-support-banner">
            <div>
              For any electricity-related issues, contact our <strong>24x7 Customer Support</strong> at
              <strong>1912 (Calls made from within Assam) / 0361–3126201  or 0361-2803200 (Calls made from outside
                Assam)</strong> or email at
              <strong>support@apdcl.org</strong>
            </div>
            <div style="margin-top: 1px;">
              (বিদ্যুৎ সম্পৰ্কীয় যিকোনো সমস্যাৰ বাবে আমাৰ <strong>২৪x৭ গ্ৰাহক সহায়ক নম্বৰ </strong>
              <strong>১৯১২ (অসমৰ পৰা অহা ফোন কলৰ বাবে) / ০৩৬১–৩১২৬২০১ বা ০৩৬১–২৮০৩২০০ (অসমৰ বাহিৰৰ পৰা অহা ফোন কলৰ
                বাবে)</strong> বা
              <strong>support@apdcl.org</strong> ই-মেইলত যোগাযোগ কৰক)
            </div>
          </router-link>
        </b-col>
      </b-row>

      <br>

      <b-row>
        <b-col cols="12" lg="9" class="banner-pc">
          <Banner />
        </b-col>
        <b-col cols="12" lg="3" class="payment-pc">
          <Payment />
        </b-col>
      </b-row>

      <b-row class="bottom-nav-row">
        <b-col lg="12" sm="12">
          <BottomFixedNav />
        </b-col>
      </b-row>

      <br>
      <b-row class="section-spacing">
        <b-col cols="12">
          <HomepageCardComponents />
        </b-col>
      </b-row>
      <br>

      <b-row class="section-spacing">
        <b-col cols="12">
          <Footer />
        </b-col>
      </b-row>
    </b-container>

    <b-modal id="startupModal" centered title="Be Alert, Be Safe!!" :static="true" hide-footer style="color:red"
      size="l">
      <b-img src="https://www.apdcl.org/website/docs/gallery/banner/scamalert2.jpg" class="img-fluid"
        style="border:1px solid grey;"></b-img>
    </b-modal>

  </div>
</template>

<script>
// @ is an alias to /src
import Banner from '@/components/HomeBanner.vue'
import Payment from '@/components/HomePayment.vue'
import BottomFixedNav from '@/components/HomeBottomFixedNav.vue'
import HomepageCardComponents from '@/components/HomeCardComponents.vue'
import Header from '@/components/Header.vue'
import Footer from '@/components/Footer.vue'
import { mapGetters, mapActions } from 'vuex'

export default {
  name: 'Home',
  components: {
    'Banner': Banner,
    'Payment': Payment,
    'BottomFixedNav': BottomFixedNav,
    'HomepageCardComponents': HomepageCardComponents,
    'Header': Header,
    'Footer': Footer
  },

  data() {
    return {

      activeMenuItem: null,
      allOpenOnLoad: true,
      autoCloseTimer: null,

      menuItems: [
        { id: 'menuItem0', top: '32vh', icon: 'phone', label: 'APDCL EasyPay', href: 'https://www.apdclrms.com/easypay/login', target: '_blank' },
        { id: 'menuItem1', top: '40vh', icon: 'lightning', label: 'Voluntary Load Declaration Scheme', href: 'VldScheme', target: null },
        { id: 'menuItem2', top: '48vh', icon: 'card-list', label: 'Holding No Update', href: 'HoldingNoUpdate', target: null },
        { id: 'menuItem3', top: '56vh', icon: 'layers', label: 'Compliance of Sec 194Q', href: 'TanUpdate', target: null },
        { id: 'menuItem4', top: '64vh', icon: 'pencil', label: 'Register Complaint', href: 'http://www.bijuleebandhu.com/', target: '_blank' },
        // { id: 'menuItem5', top: '72vh', icon: 'exclude', label: 'EODB', href: 'EodbReport', target: null }
      ],

      getMarqueeFields: [
        { key: 'title', label: '' }
      ]
    }

  },
  computed:
  {
    ...mapGetters([
      'getMarquee'
    ])
  },
  methods: {
    ...mapActions([
      'retrieveMarquee'
    ]),

    openNav(id) {
      this.allOpenOnLoad = false;
      this.activeMenuItem = id;
    },

    closeNavAll() {
      this.allOpenOnLoad = false;
      this.activeMenuItem = null;
    }

  },

  beforeMount() {
    if (this.getMarquee.length == 0) {
      this.retrieveMarquee();
    }
  },
  mounted() {
    this.$bvModal.show('startupModal');

    // Briefly show all quick-link panels open on load, then collapse
    // into normal hover-to-open behavior.
    this.autoCloseTimer = setTimeout(() => {
      this.allOpenOnLoad = false;
    }, 30000);
  },
  beforeDestroy() {
    if (this.autoCloseTimer) {
      clearTimeout(this.autoCloseTimer);
    }
  }
}
</script>


<style scoped="true">
.home-container {
  padding-top: 100px;
}

.quick-links-row {
  color: #424242;
  height: 2vh;
  margin-top: -9vh;
  margin-bottom: 4vh;
}

.bottom-nav-row {
  margin-left: -30px;
  margin-right: -30px;
  padding-top: 5vh;
}

.section-spacing {
  padding-top: 10px;
}

.app-update-ribbon {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;

  background: linear-gradient(90deg, #fff3e0, #ffcc80);
  color: #e65100;

  padding: 12px 16px;
  border-left: 6px solid #fb8c00;
  border-radius: 6px;

  font-size: 0.85rem;
  font-weight: 600;

  text-align: center;
  margin-bottom: 10px;
  margin-left: 20px;
}

.app-update-ribbon svg {
  margin-right: 2px;
  font-size: 0.95rem;
}

.customer-support-banner {
  display: block;
  background-color: #fff8e1;
  color: #444;
  border-left: 6px solid #0277bd;
  border-right: 6px solid #0277bd;
  border-top: 6px solid #0277bd;
  border-bottom: 6px solid #0277bd;
  padding: 10px 10px;
  font-size: 1rem;
  font-weight: 500;
  text-decoration: none;
  border-radius: 10px;
  box-shadow: 2px 4px 10px rgba(0, 0, 0, 0.15);
  margin-bottom: 1px;
  margin-left: 20px;
  line-height: 1.6;
  position: relative;
  transition: transform 0.2s ease, box-shadow 0.2s ease;
}

.customer-support-banner:hover {
  transform: translateY(-2px);
  box-shadow: 4px 6px 12px rgba(0, 0, 0, 0.2);
  background-color: #ffecb3;
  cursor: pointer;
}

#fixedButton {
  height: 40vh;
  top: 32vh;
  left: 0;
  position: fixed;
  z-index: 100;
  font-size: 1.6vw;
  cursor: pointer;
  border: 1px solid #bf360c;
  background-color: #e44c15d6;
  border-radius: 0 10px 10px 0;
  transition: 0.5s;
  padding: 10px;
}

#fixedButton ul {
  list-style: none;
  margin: 0;
  padding: 0;
}

.menu-nav-item {
  height: 8vh;
  border-bottom: 1px solid #ffffff;
  outline: none;
  transition: background-color 0.2s ease;
}

.menu-nav-item:nth-child(1),
.menu-nav-item:nth-child(2) {
  height: 7vh;
}

.menu-nav-item:last-child {
  border-bottom: none;
}

.menu-nav-item-active {
  background-color: rgba(255, 255, 255, 0.18);
}

.sidenav {
  height: 8vh;
  width: 0;
  position: fixed;
  z-index: 101;
  left: 0;
  border: 1px solid #e64a19;
  background-color: #e44c15e8;
  overflow-x: hidden;
  overflow-y: hidden;
  transition: width 0.5s ease;
  cursor: default;
  border-radius: 0 10px 10px 0;
}

.sidenav.open {
  width: 23vw;
}

.sidenav a {
  padding: 10px 8px 0 8px;
  text-decoration: none !important;
  text-align: left;
  color: #ffffff !important;
  display: block;
  white-space: nowrap;
  font-size: 1rem;
  font-weight: 500;
}

.sidenav a:hover {
  color: #212121 !important;
}

@media screen and (max-height: 450px) {
  .sidenav {
    padding-top: 15px;
  }

  .sidenav a {
    font-size: 18px;
  }
}

.home {
  margin-top: 0px;
  min-height: 100vh;
  background-image: url('../assets/bg4.jpg');
  background-repeat: no-repeat;
  background-attachment: fixed;
  background-size: 100% 100%;
  box-shadow: inset 0 0 0 2000px #ffffffbf;
}

.banner-mb {
  display: none;
}

.payment-mb {
  display: none;
}

.ticker-wrap {
  overflow: hidden;
  white-space: nowrap;
  width: 100%;
}

.ticker-move {
  display: inline-block;
  padding-left: 100%;
  animation: ticker-scroll 160s linear infinite;
}

.ticker-item {
  display: inline-block;
}

.ticker-sep {
  padding: 0 10px;
  opacity: 0.6;
}

@keyframes ticker-scroll {
  0% {
    transform: translateX(0);
  }

  100% {
    transform: translateX(-100%);
  }
}

.m-text {
  padding: 10px 10px 0px 10px;
}
</style>